export default __webpack_public_path__ + "static/BaysieLogo-cd4e90a6f85b991f1e0e0b13994f0bfc.svg";